/**
 * 배우 사진을 쉽게 가져가지 못하게 한다.
 *
 * 우클릭 메뉴(이미지 저장·복사)와 드래그해서 끌어내기를 막는다.
 * 사진은 배우 본인의 것이고, 프로필을 보러 온 사람이 바로 퍼갈 수 있는 상태로
 * 두지 않는다는 뜻이다.
 *
 * 다만 이것은 '문턱'이지 보호가 아니다. 화면 캡처, 개발자 도구, 이미지 주소를
 * 직접 여는 것은 그대로 된다. 정말 막아야 한다면 서명된 URL이나 워터마크처럼
 * 서버 쪽 장치가 필요하다.
 */
export const imageProtectionProps = {
  onContextMenu: (e) => e.preventDefault(),
  onDragStart: (e) => e.preventDefault(),
  draggable: false,
  style: {
    WebkitUserSelect: 'none',
    userSelect: 'none',
    WebkitTouchCallout: 'none',   // iOS 길게 누르기 메뉴
  },
};

/**
 * 이미지에 그대로 펼쳐 넣는다. 넘긴 style은 보호용 style 위에 덧칠된다.
 * @example <img {...protectedImageProps({ width: '100%' })} src={url} alt="" />
 */
export function protectedImageProps(style) {
  return {
    ...imageProtectionProps,
    style: { ...imageProtectionProps.style, ...style },
  };
}
